import BotCard from "../components/ui/BotCard";
import LoadingSkeleton from "../components/ui/LoadingSkeleton";
import { useApi } from "../hooks/useApi";

export default function MyBots() {
  const { data, loading, refresh } = useApi("/api/miniapp/bots", { bots: [] });
  return <main><h1 className="text-2xl font-black">My Bots</h1><p className="mt-1 text-sm text-tg-hint">Start, stop, inspect, and manage your bots.</p><div className="mt-5 grid gap-3">{loading ? <LoadingSkeleton /> : data.bots.map((bot) => <BotCard key={bot._id} bot={bot} onToggle={refresh} />)}</div></main>;
}
